import { Button } from 'antd';
import React, { useState } from 'react';
import { fetchPaymentAccountRotation } from '../../api';
import message from '~/utils/message';

const AutoSelectButton = ({
  onSelect,
}: {
  onSelect: (value: string) => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [isAutoEnabled, setIsAutoEnabled] = useState(true);

  const onClick = async () => {
    try {
      setLoading(true);
      const response = await fetchPaymentAccountRotation();
      if (response.accountCode) {
        onSelect(response.accountCode);
        setIsAutoEnabled(false);
      } else {
        throw new Error();
      }
    } catch (_) {
      message.error('Gagal auto pilih, silakan coba beberapa saat lagi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      type="primary"
      size="large"
      onClick={onClick}
      disabled={!isAutoEnabled}
      loading={loading}
    >
      Auto Pilih
    </Button>
  );
};

export default AutoSelectButton;
